<template>
  <div class="card2">
    <div class="bg" :style="{backgroundImage: 'url(' + item.cover + ')'}" @click.stop="goDetail">
      <liveStatus :item="item" v-if="[83, 84, 89].includes(item.type) && !item.hiddenLiveStatus"></liveStatus>
      <div class="play_icon" v-if="!isNft && (item.type === 1 && item.playIcon || item.type === 2)"></div>
      <div class="audio_icon" v-if="!isNft && (item.type === 5 || item.type === 25)"></div>
      <div class="nft_icon" v-if="isNft"></div>
    </div>
    <div class="cardInfo">
      <div class="title two_line" @click.stop="goDetail">
        <span style="color: #008BFF;" v-if="item.zhuanti">专题 | </span>
        <span>{{ item.title }}</span>
      </div>
      <div class="otherInfo flex_center">
        <div class="sourceInfo flex_row flex_center">
          <div class="flex_row flex_center">
            <div class="logo_box" v-if="userInfo.logo !== ''">
              <img class="sourceImg" :src="userInfo.logo" alt="">
              <img class="v_icon" :src="item.xinhua.vimgUrl" alt=""
                   v-if="item.xinhua && item.xinhua.vflag">
            </div>
          </div>
          <div class="sourceName">{{ userInfo.name }}</div>
          <div class="sourceName" v-if="item.commentNum">{{ item.commentNum }}评</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import liveStatus from '@/pages/ProductDetail/components/liveStatus'

export default {
  name: 'card2',
  props: [ 'item' ],
  components: {
    liveStatus
  },
  computed: {
    // 是否是数藏稿
    isNft () {
      return this.item.type === 1 &&
        this.item.isLink &&
        this.item.content.indexOf( 'https://my-h5news-test.app.xinhuanet.com/xhdc/' ) === 0
    },
    // 用户信息
    userInfo () {
      let item = this.item
      let userInfo = {
        logo: '',
        name: item.sourceName || ''
      }
      if ( item.cuser ) {
        userInfo.logo = item.cuser.logo
        userInfo.name = item.cuser.name
        userInfo.uuid = item.cuser.cuserThirdId
      }
      if ( item.xinhua ) {
        userInfo.logo = item.xinhua.xinhuaCover
        userInfo.name = item.xinhua.xinHuaName
        userInfo.uuid = item.xinhua.xinHuaUuid
      }
      return userInfo
    }
  },
  methods: {
    // 打开详情
    goDetail () {
      this.$emit( 'pauseMedia' )
      window.goDetail( this.item )
    }
  }
}
</script>

<style scoped>
.card2 {
  width: 100%;
  height: 281px;
  padding: 5px 5px 12px;
  box-sizing: border-box;
  background-image: url("../../../assets/images1/recommend/showType2_bg.png");
  background-size: cover;
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  border-radius: 12px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 6%);
}

.bg {
  width: 100%;
  height: 187px;
  background-size: cover;
  background-position: 50%;
  margin-bottom: 12px;
  border-radius: 12px;
  position: relative;
}

.play_icon {
  width: 30px;
  height: 30px;
  background-image: url("../../../assets/images1/card/video_play.png");
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  position: absolute;
  left: 10px;
  bottom: 10px;
  z-index: 1;
}

.audio_icon {
  width: 30px;
  height: 30px;
  background-image: url("../../../assets/images1/card/audio_play.png");
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  position: absolute;
  left: 10px;
  bottom: 10px;
  z-index: 1;
}

.nft_icon {
  width: 32px;
  height: 16px;
  background-image: url("../../../assets/images1/card/nft_icon.png");
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  position: absolute;
  left: 10px;
  bottom: 10px;
  z-index: 1;
}
</style>

<style scoped>
.cardInfo {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
}

.title {
  flex: 1;
  padding: 0 8px 0 6px;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 8px;
}

.otherInfo {
  padding: 0 8px 0 6px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}

.sourceInfo {
  font-size: 12px;
  line-height: 18px;
  color: rgba(255, 255, 255, .65);
  font-weight: 400;
}

.sourceImg {
  width: 18px;
  height: 18px;
  display: block;
  margin-right: 10px;
  border-radius: 50%;
  object-fit: cover;
}

.logo_box {
  width: 20px;
  height: 19px;
  margin-right: 10px;
  position: relative;
}

.v_icon {
  width: 8px;
  height: 8px;
  object-fit: cover;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.sourceName {
  margin-right: 8px;
}
</style>